import { put } from "redux-saga/effects";
import { WalletSummaryResponse } from "redmond";
import { actions } from "../../actions";
import { fetchTravelWalletSummary } from "../../../../api/v0/travel-wallet/fetchTravelWalletSummary";
import { actions as walletActions } from "../../../travel-wallet/actions";

export function* fetchTravelWalletSummarySaga() {
  try {
    const summaryResponse: WalletSummaryResponse =
      yield fetchTravelWalletSummary();

    yield put(actions.setTravelWalletCredit(summaryResponse.credit));
    yield put(
      walletActions.setTravelWalletCredit(summaryResponse.creditBreakdown)
    );
    yield put(actions.setFetchTravelWalletSummaryCallStateSuccess());
  } catch (e) {
    yield put(actions.setFetchTravelWalletSummaryCallStateFailure());
  }
}
